module.exports = __webpack_public_path__ + "img/Rock-Godbull_35_NOBG_.0010.71d87168.webp";